<template>
	<v-app style="background-color: white">
		<router-view/>
	</v-app>
</template>

<script>
export default {
	name: "App",
	components: {},
	data: () => ({})
};
</script>